module.exports = __webpack_public_path__ + "img/bonhommeVert.e021ffea.png";